import { Route, Routes } from "react-router-dom";
import { CssBaseline, Stack, ThemeProvider } from "@mui/material";
import { Navbar } from "./components/organisms/Navbar";
import theme from "./Theme";
import { Home } from "./components/pages/Home";
import { Footer } from "./components/templates/Footer";
import { Blog } from "./components/pages/blog";
import { BlogPost } from "./components/pages/blog/BlogPost";
import ScrollToTop from "./services/ScrollToTop";
import Produk from "./components/pages/produk";
import ProdukDetail from "./components/pages/produk/ProdukDetail";
import TentangKami from "./components/pages/tentang-kami";
import Promo from "./components/pages/promo";
import ErrorPage from "./components/pages/error";
import React from "react";
import { apiUrls, engine } from "./services/apiService";
import SegampangItu from "./components/pages/promo/segampangitu";
import { useQuery } from "@tanstack/react-query";
import Shortlink from "./components/pages/shortlink";
import DownloadApp from "./components/organisms/DownloadApp";
import DownloadPage from "./components/pages/download";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import EventForm from "./components/pages/event-form";
import { lazy } from "react";

const SuccessLazyPage = lazy(() =>
  import("./components/pages/verification/success")
);
const FailedLazyPage = lazy(() =>
  import("./components/pages/verification/failed")
);

const routes = [
  { path: "/", element: <Home />, showFooterDisclaimer: false },
  { path: "/blog", element: <Blog />, showFooterDisclaimer: false },
  { path: "/blog/:slug", element: <BlogPost />, showFooterDisclaimer: false },
  { path: "/produk", element: <Produk />, showFooterDisclaimer: false },
  {
    path: "/produk/:id",
    element: <ProdukDetail />,
    showFooterDisclaimer: false,
  },
  {
    path: "/tentang-kami",
    element: <TentangKami />,
    showFooterDisclaimer: false,
  },
  { path: "/promo/:slug", element: <Promo />, showFooterDisclaimer: false },
  {
    path: "/segampangitu",
    element: <SegampangItu />,
    showFooterDisclaimer: false,
  },
  {
    path: "/download",
    element: <DownloadPage />,
    showFooterDisclaimer: false,
  },
  { path: "/404", element: <ErrorPage /> },
  { path: "/:shortlink", element: <Shortlink />, showFooterDisclaimer: false },
  { path: "*", element: <ErrorPage /> },
  {
    path: "/verifikasi/:type/berhasil",
    element: <SuccessLazyPage />,
  },
  {
    path: "/verifikasi/:type/gagal",
    element: <FailedLazyPage />,
  },
  {
    path: "/event-form",
    element: <EventForm />,
  },
];

function App() {
  const { data: promoData } = useQuery({
    queryKey: ["promoData"],
    queryFn: async () => {
      const res = await engine.get(apiUrls.promo.getPromos);

      const resData = res?.data?.data;

      return resData;
    },
  });

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Routes>
        {routes?.map((route, index) => (
          <Route
            key={index}
            path={route?.path}
            element={
              <ScrollToTop>
                <Stack height="100%">
                  <ToastContainer theme="colored" position="top-right" />
                  <Navbar promo={promoData} />
                  {route?.element}
                  <DownloadApp />
                  <Footer showDisclaimer={route?.showFooterDisclaimer} />
                </Stack>
              </ScrollToTop>
            }
          />
        ))}
      </Routes>
    </ThemeProvider>
  );
}

export default App;
